import LineLoader from '@cp/src/components/SkeletonLoader/LineLoader';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import styles from './index.module.scss';
import cx from 'classnames';
import { ICustomerDetailValue } from '../../types';

const CustomerDetailValue = (props: ICustomerDetailValue) => {
  const { children, loading, hideTicketStatus, containerClass } = props;
  return (
    <SuspenseLoader
      loading={loading}
      fallBack={
        <LineLoader
          containerStyle={cx('flex-1', containerClass)}
          numberOfLines={1}
          childrenType="H4"
          dimenshionUnit="px"
          lineStyle={cx(styles.lineLoader, { [styles.lineLoaderHeight]: hideTicketStatus })}
        />
      }
    >
      {children}
    </SuspenseLoader>
  );
};

export default CustomerDetailValue;
